import * as z from 'zod';

export const SignInSchema = z.object({
  username: z.string({ required_error: 'username_required' }),
  password: z.string({ required_error: 'password_required' }).min(6, { message: 'password_min_length_six' }),
});

export type ISignInSchema = z.infer<typeof SignInSchema>;
